__turbopack_context__.v({
  "className": "plus_jakarta_sans_2146521b-module__qe1z7q__className",
});
